import controller from './verify.controller';
import './verify.scss';

let verifyComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        $transition$: '<'
    },
    template: '<div class="verify" ui-view></div>',
    controller,
    controllerAs: 'verifyCtrl'
};

export default verifyComponent;



// WEBPACK FOOTER //
// ./src/app/components/page/verify/verify.component.js